import { createTheme, ThemeProvider } from '@mui/material';
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import CustomToolbar from '../../../CommonComponents/CustomToolbar'
import MUIDataTable from 'mui-datatables';
import TourServices from '../../Invoice/TourServices';
import Footer from '../../../Component/Footer';
import Header from '../../../Component/Header';
import Menu from '../../../Component/Menu';
import withRouter from '../../../withRouter';


const theme = createTheme({
  overrides: {
    MuiTableCell: {
      head: {
        backgroundColor: "#e9ecef !important",
        border: [[1, "solid", "#ece6e6"]],
      },
      body: {
        border: [[1, "solid", "#ece6e6"]],
      },
    },
  },
});


const MHotelMealsPlanList = () => {
  const [meals, setMeals] = useState([]);

  useEffect(() => {
    getMealsPlanLists();
  }, [])

  const delteDataHandler = (e) => {
    if (confirm('Are you sure you want to Delete this thing into the database?')) {
      TourServices.deleteMMealsPlan(e).then((r) => {
        console.log(r.data);
        getMealsPlanLists();
      })
            
      console.log('Thing was Deleted to the database.');
    } else {
      
      console.log('Thing was not Deleted to the database.');
    }
    
  }

  const getMealsPlanLists = () => {
    TourServices.getAllMMealsPlanist().then((r) => {
      console.log(r.data);
      setMeals(r.data);

    })
  }
  const columns = [
    {
      name: "id",
      label: "ID",
      options: { filter: true, sort: true },
    },
    {
      name: "mealsplan",
      label: "Meals Plan",
      options: { filter: true, sort: true },
    },
    {
      name: "Action",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <button
                  as="button"
                  data-tip
                  data-for="delete"
                  className="btn btn-sm deletebutton"
                  onClick={()=>
                delteDataHandler(tableMeta.rowData.find(e=>e))
                  }
                >Delete</button>
               <Link as="button" className="btn btn-sm hovbuttonColour mr-2"
                  to={{ pathname: "/hotelmealsplan"}}  state= {{id: tableMeta.rowData.find(e=>e) ,pagename:"Edit Hotel Meals Plan" }}>Edit</Link>
                <br/>
                
               
            </>
          );
        },
      },
    },
  ];

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    customToolbar: () => {
      return (
        <>
          (
            <Link
            as="button"
            className="float-right btn btn-sm m-0 p-0"
            to={{ pathname: "/hotelmealsplan"}} 
            state= {{id: -1,pagename:"Add Hotel Meals Plans" }}
          >
            <CustomToolbar />
          </Link>
          )
        </>
      );
    },
  };

  return (
    <>
      <Header />
      <Menu />
      <div className="content-wrapper w-100% h-100%">
        <div className="card">
          <ol className="breadcrumb float-sm-right">
          <span
                as="button"
                className=" text-secondary cursorPointer"
                
              >
                <Link to="/masterpage" style={{color:"grey"}}>❮ Back &nbsp;&nbsp;</Link>
                
              </span>
            <li className="breadcrumb-item text-secondary">
              <Link to="/index">Home</Link>
            </li>
            <li className="breadcrumb-item text-secondary">
              <Link to="/masterpage">Tours & Travellers </Link>
            </li>
            <li className="breadcrumb-item active">Hotel Meals Plans</li>
          </ol>
          <div className='card'>
            <div className='card-body'>

              <ThemeProvider theme={theme}>
                <MUIDataTable
                  className="table-sm px-3"
                  title={"Meals Plan"}
                  data={meals}
                  columns={columns}
                  options={options}
                />
              </ThemeProvider>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default withRouter(MHotelMealsPlanList);